import Transactions from ".";
import TaxSetting from "./taxSetting";

export const transactionRoute = () => [
  {
    path: "/:lang/user/myEvent/transactions/:eventId",
    title: "Transaction",
    layout: "frontUserInner",
    routeType: "organization",
    component: Transactions,
  },
  {
    path: "/:lang/user/myEvent/taxSetting/:eventId",
    title: "Tax settings",
    layout: "frontUserInner",
    routeType: "organization",
    component: TaxSetting,
  },
];
